// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SxYL","left":"styles_left__1WUAr","desktopActions":"styles_desktopActions__5fAfg","title":"styles_title__30xx-"};